export default "__VITE_ASSET__Ngmgj7KrmSrUoXH_NFNtFA__";